import { render, staticRenderFns } from "./mini-dashlet.vue?vue&type=template&id=8da7ba3c"
import script from "./mini-dashlet.vue?vue&type=script&lang=js"
export * from "./mini-dashlet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports